import type { GenericErrorResponse, GenericErrorWithSuggestionResponse } from "@globals";
import type { GenericSchema } from "valibot";
import { object, record, safeParse, string, unknown } from "valibot";

export const badRequestWithSuggestionResponseSchema = object({
  message: string(),
  extra: object({ suggestion: string() })
}) satisfies GenericSchema<GenericErrorWithSuggestionResponse>;

export const badRequestResponseSchema = object({
  message: string(),
  extra: record(string(), unknown())
}) satisfies GenericSchema<GenericErrorResponse>;

export default class BadRequestErrorResponse extends Error {
  public extra: Record<string, unknown> = {};

  constructor(
    readonly response: Response,
    readonly json: unknown
  ) {
    super(`BadRequestErrorResponse: ${response.status} ${response.statusText}`);
    const parsed = safeParse(badRequestResponseSchema, json);
    if (parsed.success) {
      this.message = parsed.output.message;
      this.extra = parsed.output.extra;
    } else {
      console.error("Failed to parse BadRequestErrorResponse:", parsed.issues, json, response);
    }
  }
}
